import { useState, useEffect } from 'react';

interface HeaderProps {
  mobileMenuOpen: boolean;
  setMobileMenuOpen: (open: boolean) => void;
}

export default function Header({ mobileMenuOpen, setMobileMenuOpen }: HeaderProps) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'About', href: '#about' },
    { name: 'Technology', href: '#technology' },
    { name: 'Case Studies', href: '#voice' },
    { name: 'Process', href: '#steps' },
    { name: 'FAQ', href: '#faq' },
    { name: 'News', href: '#news' },
  ];

  return (
    <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-white/95'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center">
              <a href="#" className="flex items-center">
                <img 
                  src="https://public.readdy.ai/ai/img_res/b39bdcd8dc5ed997a25aefd8b9ffff1d.jpg" 
                  alt="アシーブメント UFB DUAL" 
                  className="h-12 w-auto"
                />
              </a>
              <div className="ml-4 hidden lg:block">
                <p className="text-xs text-gray-600">ウルトラファインバブル水を住宅全体で使える水道機器</p>
              </div>
            </div>

            <nav className="hidden lg:flex items-center space-x-6">
              {navItems.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="text-sm text-gray-700 hover:text-blue-500 transition-colors whitespace-nowrap"
                >
                  {item.name}
                </a>
              ))}
            </nav>

            <div className="hidden lg:flex items-center space-x-4">
              <a
                href="tel:080-4010-5475"
                className="flex items-center text-sm text-gray-700 hover:text-blue-500 transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-fill mr-2"></i>
                お電話でのお問い合わせ
              </a>
              <a
                href="#contact"
                className="bg-blue-500 text-white px-6 py-2 rounded-full hover:bg-blue-600 transition-colors text-sm whitespace-nowrap"
              >
                お問い合わせ
              </a>
            </div>

            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            >
              <div className="w-6 flex flex-col space-y-1.5">
                <span className={`block h-0.5 bg-gray-700 transition-all ${mobileMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
                <span className={`block h-0.5 bg-gray-700 transition-all ${mobileMenuOpen ? 'opacity-0' : ''}`}></span>
                <span className={`block h-0.5 bg-gray-700 transition-all ${mobileMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
              </div>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      <div className={`fixed inset-0 z-40 lg:hidden transition-opacity duration-300 ${mobileMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}>
        <div className="absolute inset-0 bg-black/50" onClick={() => setMobileMenuOpen(false)}></div>
        <div className={`absolute right-0 top-0 bottom-0 w-80 bg-white shadow-xl transition-transform duration-300 ${mobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}>
          <div className="p-6">
            <nav className="space-y-4 mt-16">
              {navItems.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  onClick={() => setMobileMenuOpen(false)}
                  className="block text-gray-700 hover:text-blue-500 transition-colors py-2"
                >
                  {item.name}
                </a>
              ))}
              <a
                href="tel:080-4010-5475"
                className="block text-gray-700 hover:text-blue-500 transition-colors py-2"
              >
                <i className="ri-phone-fill mr-2"></i>
                お電話でのお問い合わせ
              </a>
              <a
                href="#contact"
                onClick={() => setMobileMenuOpen(false)}
                className="block bg-blue-500 text-white px-6 py-3 rounded-full hover:bg-blue-600 transition-colors text-center"
              >
                お問い合わせ
              </a>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
}
